import React, { ReactNode } from 'react';
import { MsalProvider as DefaultMsalProvider } from '@azure/msal-react';
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult
} from '@azure/msal-browser';
import { msalConfig } from 'configs/msalConfig';

interface MsalProviderProps {
  children: ReactNode;
}

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

export const MsalProvider: React.FC<MsalProviderProps> = ({ children }) => {
  return <DefaultMsalProvider instance={msalInstance}>{children}</DefaultMsalProvider>;
};
